import { Fragment } from "react";
import { formatCost, formatMilliseconds } from "@/helpers/utils";
import { useAppState } from "@/modules/app/useAppContext";
import { StreamlitNotebookJobRunsSummaryDataResponse } from "@/pages/query/types";
import { Stack } from "@altimateai/lego";

export const CommonSummary = ({
  summaryData,
}: {
  summaryData: StreamlitNotebookJobRunsSummaryDataResponse;
}) => {
  const { currency } = useAppState();
  if (!summaryData) {
    return null;
  }
  const items = [
    {
      value: formatMilliseconds(summaryData.avg_execution_time),
      label: "Average runtime",
    },
    {
      value: formatMilliseconds(summaryData.max_execution_time),
      label: "Max runtime",
    },
    {
      value: formatMilliseconds(summaryData.min_execution_time),
      label: "Min runtime",
    },
    {
      value: summaryData.run_count,
      label: "Total runs",
    },
    {
      value: (summaryData.success_count / summaryData.run_count).toFixed(2),
      label: "Success ratio",
    },
    {
      value: formatCost(summaryData.avg_cost, currency),
      label: "Average cost",
    },
  ];

  return (
    <Stack
      align={"center"}
      wrap
      justify={"between"}
      className="al-w-full "
      tag="dl"
      aria-label="Summary"
    >
      {items.map(item => (
        <Fragment key={item.label}>
          <dt className="al-text-light-gray">{item.label}:</dt>
          <dd aria-label={item.label} className="al-font-semibold al-m-0">
            {item.value}
          </dd>
        </Fragment>
      ))}
    </Stack>
  );
};
